// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-register-component .wm-registeruser-form {
  padding: 15px;
}
wm-register-component .wm-registeruser-form .wm-registeruser-label {
  font-size: var(--wm-font-sm);
  font-weight: var(--wm-font-weight-bold);
}
wm-register-component .wm-registeruser-form .wm-registeruser-field-container {
  margin-bottom: 15px;
  position: relative;
}
wm-register-component .wm-registeruser-form .wm-registeruser-field-container .wm-registeruser-field {
  --padding-start: 0;
}
wm-register-component .wm-registeruser-form .wm-registeruser-field-container .wm-registeruser-field.item-has-focus {
  --border-color: var(--wm-color-secondary);
}
wm-register-component .wm-registeruser-form .wm-registeruser-field-container .wm-registeruser-field.wm-registeruser-field-has-error {
  --border-color: var(--ion-color-danger);
}
wm-register-component .wm-registeruser-form .wm-registeruser-field-container .wm-registeruser-field-error {
  color: var(--ion-color-danger);
  font-size: var(--wm-font-sm);
}
wm-register-component .wm-registeruser-form .wm-registeruser-field-container .wm-registeruser-extrainfo {
  position: absolute;
  top: 0;
  right: 0;
  font-size: var(--wm-font-xsm);
}
wm-register-component .wm-registeruser-form .wm-registeruser-policy {
  display: block;
  padding: 10px 40px;
  font-size: var(--wm-font-sm);
  color: var(--wm-color-grey);
}
wm-register-component .wm-registeruser-form .wm-registeruser-policy .wm-registeruser-policylink {
  text-decoration: none;
  letter-spacing: normal;
}
wm-register-component .wm-registeruser-form .wm-registeruser-buttoncontainer {
  width: 100%;
  text-align: center;
  padding: 20px 0;
}
wm-register-component .wm-registeruser-form .wm-registeruser-buttoncontainer .wm-registeruser-button {
  --border-radius: 20px;
  --padding-start: 80px;
  --padding-end: 80px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/register/register.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AACI;EACI,4BAAA;EACA,uCAAA;AACR;AACI;EACI,mBAAA;EACA,kBAAA;AACR;AAAQ;EACI,kBAAA;AAEZ;AAAY;EACI,yCAAA;AAEhB;AAAY;EACI,uCAAA;AAEhB;AACQ;EACI,8BAAA;EACA,4BAAA;AACZ;AAEQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,6BAAA;AAAZ;AAII;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,2BAAA;AAFR;AAGQ;EACI,qBAAA;EACA,sBAAA;AADZ;AAKI;EACI,WAAA;EACA,kBAAA;EACA,eAAA;AAHR;AAIQ;EACI,qBAAA;EACA,qBAAA;EACA,mBAAA;AAFZ","sourcesContent":["wm-register-component{\n  .wm-registeruser-form {\n    padding: 15px;\n    .wm-registeruser-label {\n        font-size: var(--wm-font-sm);\n        font-weight: var(--wm-font-weight-bold);\n    }\n    .wm-registeruser-field-container {\n        margin-bottom: 15px;\n        position: relative;\n        .wm-registeruser-field {\n            --padding-start: 0;\n\n            &.item-has-focus {\n                --border-color: var(--wm-color-secondary);\n            }\n            &.wm-registeruser-field-has-error {\n                --border-color: var(--ion-color-danger);\n            }\n        }\n        .wm-registeruser-field-error {\n            color: var(--ion-color-danger);\n            font-size: var(--wm-font-sm);\n        }\n\n        .wm-registeruser-extrainfo{\n            position: absolute;\n            top: 0;\n            right: 0;\n            font-size: var(--wm-font-xsm);\n        }\n    }\n\n    .wm-registeruser-policy {\n        display: block;\n        padding: 10px 40px;\n        font-size: var(--wm-font-sm);\n        color: var(--wm-color-grey);\n        .wm-registeruser-policylink {\n            text-decoration: none;\n            letter-spacing: normal;\n        }\n    }\n\n    .wm-registeruser-buttoncontainer {\n        width: 100%;\n        text-align: center;\n        padding: 20px 0;\n        .wm-registeruser-button {\n            --border-radius: 20px;\n            --padding-start: 80px;\n            --padding-end: 80px;\n        }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
